const Siparis = resolve => {
    require.ensure(['../views/apps/siparis/Siparis'], () => {
        resolve(require('../views/apps/siparis/Siparis'))
    })
};
const SiparisListesi = resolve => {
    require.ensure(['../views/apps/siparis/SiparisListesi'], () => {
        resolve(require('../views/apps/siparis/SiparisListesi'))
    })
};
const Siparisler = resolve => {
    require.ensure(['../views/apps/siparis/Siparisler'], () => {
        resolve(require('../views/apps/siparis/Siparisler'))
    })
};



import Vue from 'vue'
Vue.component('SiparisListesi', SiparisListesi);
Vue.component('Siparisler', Siparisler);

export default {
    path: '/siparis',
    name: 'siparis',
    component: Siparis,
    meta: {
        auth: true,
    },
}
